<template>
    <div class="submit-spc-order">
        <el-form ref="form" label-width="100px" label-position="left">
            <div class="form-title mt10"><svg-icon icon-class="lm" class-name="lm-icon" />客户信息</div>
            <div class="info">
                <div class="info-list">
                    <div class="info-item">
                        <div class="label">ERP订单号：</div>
                        <div class="content">{{ orderInfo.submitdata.erp_sn }}</div>
                    </div>
                    <div class="flex">
                        <div class="info-item">
                            <div class="label">合同类型：</div>
                            <div class="content">{{ orderInfo.submitdata.Orders_Type == 0 ? '销售订单' :
                                orderInfo.submitdata.Orders_Type == 1 ? '服务订单' : '' }}</div>
                        </div>
                    </div>
                    <div class="flex">
                        <div class="info-item">
                            <div class="label">客户编号：</div>
                            <div class="content label-middle">{{orderInfo.submitdata.Customer_Code || orderInfo.Orders.Customer_Code }}</div>
                        </div>
                        <div class="info-item">
                            <div class="label">客户名称：</div>
                            <div class="content">{{ orderInfo.submitdata.Customer_Name }}</div>
                        </div>
                    </div>
                    <div class="flex">
                        <div class="info-item">
                            <div class="label">客户类型：</div>
                            <div class="content label-middle">{{ orderInfo.submitdata.Customer_Type == '0' ? '企业客户' :
                                '个人客户' }}</div>
                        </div>
                        <div class="info-item" v-if="orderInfo.submitdata.Customer_Type == 0">
                            <div class="label">注册所在地：</div>
                            <div class="content">{{ orderInfo.submitdata.Customer_RegAddr }}</div>
                        </div>
                    </div>

                </div>
            </div>
            <div class="form-title"><svg-icon icon-class="lm" class-name="lm-icon" />工程信息</div>
            <div class="info">
                <div class="info-list">
                    <div class="flex">
                        <div class="info-item">
                            <div class="label">工程区域：</div>
                            <div class="content">{{ orderInfo.Orders.Orders_ProjectAddress }}</div>
                        </div>
                    </div>
                    <div class="flex">
                        <div class="info-item">
                            <div class="label">工程名称：</div>
                            <div class="content">{{ orderInfo.Orders.Orders_ProjectName }}</div>
                        </div>
                    </div>
                    <div class="info-item">
                        <div class="label">行业分类：</div>
                        <div class="content">{{ Orders_ProjectTypeName }}</div>
                    </div>
                </div>
            </div>
            <div class="form-title"><svg-icon icon-class="lm" class-name="lm-icon" />合同联系人</div>
            <div class="info">
                <div class="info-list">
                    <div class="flex">
                        <div class="info-item">
                            <div class="label">联系人姓名：</div>
                            <div class="content">{{ submitdata.Orders_Contract_Name }}</div>
                        </div>
                    </div>
                    <div class="flex">
                        <div class="info-item">
                            <div class="label">联系人手机：</div>
                            <div class="content">{{ submitdata.Orders_Contract_Mobile }}</div>
                        </div>
                    </div>
                    <div class="info-item">
                        <div class="label">联系人邮箱：</div>
                        <div class="content">{{ submitdata.Orders_Contract_Email }}</div>
                    </div>
                </div>
            </div>
            <div class="form-title"><svg-icon icon-class="lm" class-name="lm-icon" />电子签章</div>
            <el-form-item label="电子签章" v-if="Orders_SourceCate == 1 || (Orders_SourceCate != 1 && TradeType != 1)">
                <el-radio-group v-model="Orders_ESignStatus">
                    <el-radio label="1">不使用</el-radio>
                    <el-radio label="2">使用</el-radio>
                </el-radio-group>
                <el-tag type="success" class="ml10" v-if="orderInfo.submitdata.Customer_IsESign == 1">已注册电子签章</el-tag>
                <div class="" v-if="orderInfo.submitdata.Customer_Type != 0">
                    <div class="u-m-t-20">
                        {{ submitdata.Orders_Contract_Name }}
                    </div>
                    <div class="u-m-t-20">
                        {{ submitdata.Orders_Contract_Mobile }}
                    </div>
                </div>
                <div class="" v-else>
                    <div class="u-m-t-20 mt10 mb10">
                        <el-input v-model="Orders_ESignName" type="text" class="el-select-big"
                            placeholder="联系人姓名" />
                    </div>
                    <div class="u-m-t-20 mt10 mb10">
                        <el-input v-model="Orders_EsignMobile" type="text" class="el-select-big"
                            placeholder="联系人手机" />
                    </div>
                </div>
            </el-form-item>
            <div class="form-title" v-if="Show_CreditInvoiceStatus"><svg-icon icon-class="lm"
                    class-name="lm-icon" />是否开具红冲发票</div>
            <el-checkbox v-if="Show_CreditInvoiceStatus" v-model="Orders_CreditInvoiceStatus"><span class="fw700"
                    style="color: red">开具红冲发票</span></el-checkbox>

            <div class="form-title"><svg-icon icon-class="lm" class-name="lm-icon" />退货清单</div>
            <el-checkbox v-model="Orders_ReturnCommitment"><span class="fw700"
                    style="color: red">退货承诺：本次退货设备已核验完毕，不影响二次销售</span></el-checkbox>
            <el-table :data="submitReturnsList.filter((item) => item.Goods_Product_Amount != 0)"
                style="width: 100%; margin-top: 10px" border :header-cell-style="{ backgroundColor: '#F5F7FA' }">
                <el-table-column prop="Goods_SaleGroupName" label="销售组" align="center"
                    show-overflow-tooltip  width="140"></el-table-column>
                <el-table-column prop="Goods_Product_Code" label="商品编码" align="center" width="100"></el-table-column>
                <el-table-column prop="Goods_Product_Name" label="商品名称" align="left"></el-table-column>
                <el-table-column prop="Product_Spc" label="规格" align="center" width="100"></el-table-column>
                <el-table-column prop="" label="已下架" align="center" width="80">
                    <template v-slot="scope">
                        <span>{{ scope.row.Product_IsInsale == 0 ? '是' : '否' }}</span>
                    </template>
                </el-table-column>
                <el-table-column prop="Goods_Product_SourcePrice" label="单价" align="center" width="100">
                    <template v-slot="scope">
                        <span class="is-status-text">￥{{ getFloat(scope.row.Goods_Product_SourcePrice, 2) }}</span>
                    </template>
                </el-table-column>
                <el-table-column prop="Deliver_Amount" label="总数" align="center" width="100"></el-table-column>
                <el-table-column prop="" label="合计" align="center" width="100">
                    <template v-slot="scope">
                        <span class="is-status-text">{{ getFloat(scope.row.Deliver_Amount *
                            scope.row.Goods_Product_SourcePrice, 2) }}</span>
                    </template>
                </el-table-column>
                <el-table-column prop="ReturnQuantity" label="可退货数量" align="center" width="100"></el-table-column>
                <el-table-column prop="Goods_Product_Price" label="退货单价" align="center" width="100">
                    <template v-slot="scope">
                        <span class="is-status-text">￥{{ getFloat(scope.row.Goods_Product_Price, 2) }}</span>
                    </template>
                </el-table-column>
                <el-table-column prop="Goods_Product_Amount" label="退货数量" align="center" width="100"></el-table-column>
            </el-table>
            <div class="action-footer">
                <span>
                    商品金额合计：
                    <span style="color: red">¥{{ getFloat(totalPrice, 2) | formatePrice3 }}</span>
                </span>
            </div>
        </el-form>
    </div>
</template>

<script>
import { getDisplayAddressStr } from '@/utils/utils.js';
import { mapState } from 'vuex';
export default {
    name: 'submitSpcOrder',
    props: {
        Customer_info: {
            type: Object,
            default: () => ({})
        },
        submitpaymentObj: {
            type: Object,
            default: () => ({})
        },
        //订单类型: 0销售订单1服务订单
        Orders_Type: {
            type: Number,
            default: 0
        },
        //交易类型:0：正常交易 1报价单2打包订单
        TradeType: {
            type: Number,
            default: 0
        },
        //合同来源: 0报价单1合同变更2独立合同
        Orders_SourceCate: {
            type: Number,
            default: 2
        },

        totalPrice: {
            type: Number,
            default: 0
        },
        submitReturnsList: {
            type: Array,
            default: () => []
        },
        orderInfo: {
            type: Object,
            default: () => ({})
        }
    },
    mounted() {
            this.Orders_ESignName = this.orderInfo.Orders.Orders_Contract_Name;
            this.Orders_EsignMobile = this.orderInfo.Orders.Orders_Contract_Mobile;
    },
    computed: {
        ...mapState({
            countryList: (state) => state.common.countryList,
            provinceList: (state) => state.common.provinceList,
            cityList: (state) => state.common.cityList,
            districtList: (state) => state.common.districtList
        })
    },
    data() {
        return {
            Orders_ESignStatus: '', // 电子签章状态
            Orders_ESignName: '', // 电子签章名称
            Orders_EsignMobile: '', // 电子签章手机号
            Orders_ReturnCommitment: false, // 退货承诺
            Orders_CreditInvoiceStatus: false, // 是否开具红冲发票
            Orders_ProjectTypeName: '', // 项目类型名称
            Show_CreditInvoiceStatus: false, // 是否显示开具红冲发票
            submitdata: {}
        };
    },
    methods: { 
        // 处理前置条件
        precondition(json) {
            this.submitdata = JSON.parse(json);
            console.log(this.submitdata, 'submitdata');
            this.$newsApi.order.DisplayProjectTypeRecursion({ ID: this.orderInfo.Orders.Orders_ProjectType_ID }).then((res) => {
                this.Orders_ProjectTypeName = res.data.data;
            });
getDisplayAddressStr(
                            this.submitdata.Customer_Project_Country,
                            this.submitdata.Customer_Project_State,
                            this.submitdata.Customer_Project_City,
                            this.submitdata.Customer_Project_County,
                            (result) => {
                                this.orderInfo.Orders.Orders_ProjectAddress = result.resultinfo;
                                console.log(result);
                            },
                            (err) => {
                                console.log(err); 
                            }
                        );

            this.Orders_ReturnCommitment = this.submitdata.Orders_ReturnCommitment == 1 ? true : false;
            this.Orders_CreditInvoiceStatus = this.submitdata.Orders_ReturnCommitment == 1 ? true : false;
            this.Show_CreditInvoiceStatus = this.submitdata.Show_CreditInvoiceStatus == 1 ? true : false;
        },
        getFormParams() {
            let params = this.submitdata;
            params.Orders_ESignStatus = this.Orders_ESignStatus;
            params.Orders_ESignName = this.Orders_ESignName;
            params.Orders_EsignMobile = this.Orders_EsignMobile;
            params.Orders_ReturnCommitment = this.Orders_ReturnCommitment ? 1 : 0;
            params.Orders_CreditInvoiceStatus = this.Orders_CreditInvoiceStatus ? 1 : 0;
            return params;
        }
    }
};
</script>

<style scoped lang="scss">
/deep/ .lm-icon{
    margin-right: 10px;
}
.mt0 {
    margin-top: 0 !important;
}

.mt10 {
    margin-top: 10px;
}

.ml10 {
    margin-left: 10px;
}
.mr10 {
    margin-right: 10px;
}
.mb10 {
    margin-bottom: 10px;
}
.tip {
    font-size: 12px;
    color: #999999;
    margin-left: 10px;
}

.form-title {
    margin: 40px 0 20px 0;
    font-size: 16px;
    font-weight: 700;
}
.flex {
    display: flex;
    align-items: center;
}
.info {
    // width: 600px;

    .info-title {
        font-size: 16px;
        font-weight: 700;
    }

    .info-item {
        display: flex;
        margin: 10px 0;
        font-size: 14px;
        color: #000000;

        .label {
            width: 100px;
        }

        .content {
            flex: 1;
            height: auto;
        }
    }

    .label-middle {
        width: 100px;
    }
}
.cart-list-container {
    border: 1px solid #e4e7ed;
    border-radius: 15px;
    padding: 20px 25px 10px 25px;
}
.cart-list {
    background-color: #ffffff;
    font-size: 14px;
    .cart-top {
        font-weight: 700;
        margin-bottom: 10px;
        .cart-top-title {
            .title-contetn {
                font-size: 14px;
                margin-right: 10px;
            }
        }
    }
    .cart-top-title-big {
        font-size: 16px;
        font-weight: 700;
        margin-bottom: 10px;
    }
}
.total {
    font-size: 14px;
    text-align: right;
    margin-top: 10px;
    span {
        color: red;
        padding-right: 20px;
    }
}
.action-footer {
    display: flex;
    justify-content: flex-end;
    padding: 20px;
}
.action-footer-btn {
    width: 100%;
    text-align: center;
}
</style>
